import React, { memo } from 'react';
import NoteNode from '../../FlowchartView/TaskNode/NoteNode';
import MilestoneNode from '../../FlowchartView/TaskNode/MilestoneNode';
import CardFace from '../CardFace';
import BoardCardMenu from './BoardCardMenu';
import { appendedOnly, sameLock } from '../utils/boardChromeKey';

function samePlace(prev, next) {
  return prev.task === next.task
    && prev.selected === next.selected
    && prev.pos?.x === next.pos?.x
    && prev.pos?.y === next.pos?.y;
}

export const BoardMission = memo(function BoardMission({
  task,
  pos,
  selected,
  flow,
  lockState,
  goToTask,
  menuActionsRef,
}) {
  return (
    <div
      className="board-view__node"
      data-board-node={task.id}
      style={{ left: pos.x, top: pos.y }}
    >
      <CardFace
        task={task}
        flow={flow}
        lockState={lockState}
        selected={selected}
        onGoToDependency={goToTask}
      />
      <BoardCardMenu task={task} flow={flow} menuRef={menuActionsRef} />
    </div>
  );
}, (prev, next) => samePlace(prev, next)
  && prev.chromeKey === next.chromeKey
  && prev.flow?.cardDisplaySettings === next.flow?.cardDisplaySettings
  && appendedOnly(prev.flow?.tasks, next.flow?.tasks)
  && sameLock(prev.lockState, next.lockState));

export const BoardNote = memo(function BoardNote({
  task,
  pos,
  selected,
  onRename,
  onDelete,
  menuActionsRef,
}) {
  return (
    <div className="board-view__node" data-board-node={task.id} style={{ left: pos.x, top: pos.y }}>
      <NoteNode
        task={task}
        position={pos}
        isSelected={selected}
        onRename={onRename}
        onDelete={onDelete}
        onCopy={() => menuActionsRef.current?.copyNode?.(task.id)}
        onDuplicate={() => menuActionsRef.current?.duplicateNode?.(task.id)}
      />
    </div>
  );
}, (prev, next) => samePlace(prev, next));

export const BoardMilestone = memo(function BoardMilestone({
  task,
  pos,
  hostPosition,
  selected,
  tasks,
  flow,
  statuses,
  menuActionsRef,
}) {
  return (
    <div className="board-view__node" data-board-node={task.id} style={{ left: pos.x, top: pos.y }}>
      <MilestoneNode
        task={task}
        position={pos}
        hostPosition={hostPosition}
        isSelected={selected}
        allTasks={tasks}
        nestedSprints={flow.nestedSprints || []}
        allSprints={flow.allSprints || []}
        statuses={statuses}
        cardDisplaySettings={flow.cardDisplaySettings || {}}
        onRename={flow.onRenameTask}
        onDelete={flow.onDeleteTask}
        onCopy={() => menuActionsRef.current?.copyNode?.(task.id)}
        onDuplicate={() => menuActionsRef.current?.duplicateNode?.(task.id)}
        onAnchorChange={flow.onMilestoneAnchorChange}
      />
    </div>
  );
}, (prev, next) => samePlace(prev, next)
  && prev.hostPosition?.x === next.hostPosition?.x
  && prev.hostPosition?.y === next.hostPosition?.y
  && prev.statuses === next.statuses
  && appendedOnly(prev.tasks, next.tasks));
